/**
 ******************************************************************************
 * @file    UTILS.js
 * @brief   This file used for different utility functions.
 ******************************************************************************
 */

export const UpdateDocumentTitle = (title) => {
  /* istanbul ignore next */
  setTimeout(() => {
    document.getElementById("MobilePageTitle").innerHTML = title;
  }, 100);
};

export const LogMessage = (message) => {
  console.log(message);
};

export function CheckResponse(response) {
  if (response.status !== true) {
    throw response["message"];
  }
  return response["message"];
}

export function SetToken(token) {
  try {
    if ("localStorage" in window && window.localStorage !== null) {
      localStorage.setItem("token", token);
    } else {
      LogMessage("localStorage not supported");
    }
  } catch (ex) {
    LogMessage(ex);
  }
}

export function GetUserToken(token) {
  try {
    if ("localStorage" in window && window.localStorage !== null) {
      return localStorage.getItem("token") || null;
    } else {
      LogMessage("localStorage not supported");
    }
  } catch (ex) {
    LogMessage(ex);
  }
}

export function ClearToken() {
  try {
    if ("localStorage" in window && window.localStorage !== null) {
      return localStorage.clear();
    } else {
      LogMessage("localStorage not supported");
    }
  } catch (ex) {
    LogMessage(ex);
  }
}

export function DisableScroll() {
  const windowBody = document.getElementsByTagName("body")[0];
  const windowHTML = document.getElementsByTagName("html")[0];
  windowBody.classList.add("scrollDisable");
  windowHTML.classList.add("scrollDisable");
}

export function EnableScroll() {
  const windowBody = document.getElementsByTagName("body")[0];
  const windowHTML = document.getElementsByTagName("html")[0];
  windowBody.classList.remove("scrollDisable");
  windowHTML.classList.remove("scrollDisable");
}
